import { ReactNode } from 'react'

import { useStyles } from '@signavio/ui'
import { ThemeT, utils, DataSourceT } from '@signavio/effektif-commons'
import { Box, Glyph } from '@signavio/ui/core'

import { getEntityDisplayName } from '../..'

type GroupTileProp = {
  group: DataSourceT

  circular?: boolean
  transparent?: boolean

  toolbar?: ReactNode
}

function GroupTile({ group, circular, transparent, toolbar }: GroupTileProp) {
  const styles = useStyles(
    defaultStyles,
    {},
    {
      '&circular': Boolean(circular),
      '&transparent': Boolean(transparent),
    }
  )

  return (
    <div
      {...styles}
      data-testid="group"
      title={getEntityDisplayName(group.name as string, 'group') as string}
    >
      <div {...styles('iconContainer')}>
        <Glyph style={styles('icon')}>user-group</Glyph>
      </div>

      <Box
        marginLeft={circular ? 'xxsmall' : 'small'}
        style={styles('content')}
      >
        {getEntityDisplayName(group.name as string, 'group', {
          styledIfUnnamed: true,
        })}
      </Box>

      {toolbar}
    </div>
  )
}

const defaultStyles = ({ color }: ThemeT) => ({
  display: 'flex',

  alignItems: 'center',

  backgroundColor: color.background,

  content: {
    flexGrow: 1,

    ...utils.ellipsis(),
  },

  iconContainer: {
    display: 'flex',

    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,

    width: 40,
    height: 40,
  },

  icon: {
    display: 'flex',

    justifyContent: 'center',
    alignItems: 'center',

    color: color.mono.middle,
    backgroundColor: color.mono.light,

    width: 40,
    height: 40,
  },

  '&circular': {
    icon: {
      borderRadius: '50%',

      width: 32,
      height: 32,
    },
  },

  '&transparent': {
    backgroundColor: null,
  },
})

export default GroupTile
